<template>
    <v-container class="fill-height" fluid>
        <v-layout align-center justify-center>
            <v-flex style="max-width: 500px;">
                <v-card class="text-center pa-8" elevation="2">
                    <v-icon size="100" color="warning" class="mb-4">mdi-alert-circle-outline</v-icon>
                    <p class="font-weight-black display-1 primary--text mb-1">404</p>
                    <p class="title font-weight-bold mb-4">Halaman yang Anda cari tidak ditemukan</p>
                    <v-divider class="mb-6"></v-divider>
                    <div class="text-left mb-6">
                        <p class="subtitle-2 font-weight-bold grey--text text--darken-2 mb-3">Kemungkinan penyebab:</p>
                        <v-list dense class="py-0 transparent">
                            <v-list-item class="px-0">
                                <v-list-item-icon class="mr-3 my-auto">
                                    <v-icon small color="grey">mdi-link-variant-off</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="body-2">URL yang dimasukkan salah atau tidak valid</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0">
                                <v-list-item-icon class="mr-3 my-auto">
                                    <v-icon small color="grey">mdi-delete-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="body-2">Halaman telah dihapus atau dipindahkan</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0">
                                <v-list-item-icon class="mr-3 my-auto">
                                    <v-icon small color="grey">mdi-lock-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="body-2">Anda tidak memiliki akses ke halaman ini</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                    <v-btn color="primary" large @click="$router.push('/')">
                        <v-icon left>mdi-home</v-icon>
                        Kembali ke Beranda
                    </v-btn>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  export default {
  }
</script>
